import { Dispatch, useCallback, useEffect, useRef } from "react";
import { UiEventTypes } from "../constants";
import { TAction } from "./ui-state-reducer.hook";

export const useUiTimeout = (dispatch: Dispatch<TAction>): (() => void) => {
  const hideTimeoutRef = useRef(-1);

  useEffect(() => () => clearTimeout(hideTimeoutRef.current), []);

  return useCallback(() => {
    dispatch({
      type: UiEventTypes.SHOW_UI,
      payload: {},
    });
    clearTimeout(hideTimeoutRef.current);

    hideTimeoutRef.current = window.setTimeout(() => {
      dispatch({ type: UiEventTypes.HIDE_UI, payload: {} });
    }, 3000);
  }, [dispatch]);
};
